var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13C15.9916 13 18.4167 10.5749 18.4167 7.58335C18.4167 4.59181 15.9916 2.16669 13 2.16669C10.0085 2.16669 7.58337 4.59181 7.58337 7.58335C7.58337 10.5749 10.0085 13 13 13Z",
    stroke: "#F5F6F6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69421 23.8333C3.69421 19.6408 7.86504 16.25 13 16.25C14.04 16.25 15.0476 16.3908 15.9901 16.6508",
    stroke: "#F5F6F6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8333 19.5C23.8333 19.8467 23.79 20.1825 23.7033 20.5075C23.6058 20.9408 23.4325 21.3634 23.205 21.7317C22.4575 22.9884 21.0816 23.8334 19.5 23.8334C18.3841 23.8334 17.3766 23.4108 16.6183 22.7175C16.2933 22.4358 16.0116 22.1 15.7949 21.7317C15.3941 21.0817 15.1666 20.3125 15.1666 19.5C15.1666 18.33 15.6325 17.2575 16.3908 16.4775C17.1816 15.665 18.2866 15.1667 19.5 15.1667C20.7783 15.1667 21.9375 15.7192 22.7175 16.6075C23.4108 17.3767 23.8333 18.395 23.8333 19.5Z",
    stroke: "#F5F6F6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1142 19.4783H17.8859",
    stroke: "#F5F6F6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 17.8967V21.1358",
    stroke: "#F5F6F6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdd);
export default __webpack_public_path__ + "static/media/user-add.bf02767623e14555fb66db5f5f4f31c2.svg";
export { ForwardRef as ReactComponent };